import { Controller } from "@hotwired/stimulus"

// Ouvre la boîte d'impression du navigateur, qui sert aussi à produire le PDF.
//
// C'était un attribut `onclick`, c'est-à-dire du script en ligne : la politique
// de sécurité de l'application (`script_src :self`, sans `unsafe_inline`) le
// bloquait, et le bouton ne faisait rien — en silence, puisqu'une violation CSP
// ne va que dans la console. Un nonce ne rattrape pas un gestionnaire porté par
// un attribut ; seul un contrôleur, chargé depuis le bundle, en sort.
export default class extends Controller {
  print() {
    window.print()
  }
}
